import * as api from '@/utils/api/api';
import {makeAutoObservable} from "mobx";
import axios from 'axios';

class ConstantStore {
    app = null;

    constructor() {
        makeAutoObservable(this)
    }
     fetchJson() {
        axios.all([api.app()]).then(
            axios.spread((app) => {
                this.app = app;
            })
        )
    }
}

export default new ConstantStore();